import React from 'react';

import Container from '@src/components/Shared/Container';
import NextImage from '@src/components/Shared/NextImage';
import RenderBodyCopy from '@src/components/Shared/RenderBodyCopy';

import { HealthGridPropTypes } from './HealthGrid.types';
import RenderButtons from '@src/components/Shared/RenderButtons';

const HealthGrid: React.FC<HealthGridPropTypes> = ({ attr, data, id }) => {
  return (
    <Container attr={attr} id={id}>
      <div className='flex flex-wrap -mx-2'>
        {data.map((item, index) => (
          <div
            key={index}
            className={`mb-[1rem] px-[0.5rem] ${index === data.length - 1 && data.length % 2 !== 0 ? 'flex w-full flex-col lg:flex-row' : 'w-full lg:w-1/2'} `}
          >
            {/* Conditionally render the layout for the last item if odd number */}
            {index === data.length - 1 && data.length % 2 !== 0 ? (
              <>
                <div className='rounded-lg border-[0.1rem] border-border lg:flex lg:w-full lg:flex-row'>
                  <NextImage
                    className={`w-full lg:w-[50%]`}
                    imgClassName='min-h-[25rem] md:min-h-min'
                    objectFit='cover'
                    src={item.mediaPrimary?.url}
                    alt='Test Image'
                  />
                  <div className='p-[2.4rem] lg:w-[50%]'>
                    <h3 className='mb-[1.8rem] text-[2.2rem] font-medium leading-[2.8rem] tracking-[-0.065rem] md:mb-[2.5rem] md:text-[2.8rem]'>
                      {item.title}
                    </h3>
                    <RenderBodyCopy
                      className='mb-[1.4rem] text-[1.6rem] text-body-copy xl:text-[1.8rem]'
                      bodyCopy={item.bodyCopy?.json?.content}
                    />
                    <RenderButtons items={item.buttonCollection?.items} />
                  </div>
                </div>
              </>
            ) : (
              // Regular items layout with content stacked in one column
              <div className='flex min-h-full w-full flex-col rounded-lg border-[0.1rem] border-border'>
                <NextImage
                  className={`w-full`}
                  imgClassName='min-h-[25rem] md:min-h-min'
                  objectFit='cover'
                  src={item.mediaPrimary?.url}
                  alt='Test Image'
                />
                <div className='p-[2.4rem]'>
                  <h3 className='mb-[1.8rem] text-[2.2rem] font-medium leading-[2.8rem] tracking-[-0.065rem] md:mb-[2.5rem] md:text-[2.8rem]'>
                    {item.title}
                  </h3>
                  <RenderBodyCopy
                    className='mb-[1.4rem] text-[1.6rem] text-body-copy xl:text-[1.8rem]'
                    bodyCopy={item.bodyCopy?.json?.content}
                  />
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </Container>
  );
};

export default HealthGrid;
